import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from "@react-pdf/renderer";
import moment from "moment";

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 15
  },
  title: {
    fontSize: 20,
    textAlign: "center",
    marginBottom: 10
  },
  author: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 5
  },
  image: {
    width: 150,
    marginVertical: 15,
    marginHorizontal: 0
  },
  fecha: {
    fontSize: 12,
    textAlign: "right"
  },
  rangoFecha: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 5
  },
  rangoFechas: {
    fontSize: 10,
    textAlign: "center"
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableColH: {
    backgroundColor: "lightblue",
    width: "14%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol: {
    width: "14%",
    borderStyle: "solid",
    borderWidth: 0,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10
  },
  footer: {
    position: "absolute",
    fontSize: 10,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey"
  }
});

// Create Document Component
const MyDocument = props => {
  const { filtros } = props;
  return (
    <Document>
      <Page size="A4" style={styles.body}>
        <View style={styles.section}>
          <Image style={styles.image} src={props.url} />
          <Text style={styles.fecha}>
            {moment(new Date()).format("DD/MM/YYYY")}
          </Text>
          <Text style={styles.title}>Reporte De Amparos Resueltos</Text>
          <Text style={styles.author}>Oral Mercantil</Text>
          {typeof filtros[2] !== "undefined" ? (
            filtros[2].length > 0 ? (
              <Text style={styles.author}>Materia: {filtros[2]}</Text>
            ) : null
          ) : null}
          {typeof filtros[3] !== "undefined" ? (
            filtros[3].length > 0 ? (
              <Text style={styles.author}>Nombre: {filtros[3]}</Text>
            ) : null
          ) : null}
          {typeof filtros[9] !== "undefined" ? (
            typeof filtros[9][0] !== "undefined" &&
            typeof filtros[9][1] !== "undefined" ? (
              <>
                <Text style={styles.rangoFecha}>Rango de Fechas</Text>
                <Text style={styles.rangoFechas}>
                  Fecha Inicio {moment(filtros[9][0]).format("DD/MM/YYYY")}{" "}
                  Fecha Fin {moment(filtros[9][1]).format("DD/MM/YYYY")}
                </Text>
              </>
            ) : null
          ) : null}
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableColH}>
                <Text style={styles.tableCell}>Caso</Text>
              </View>
              <View style={styles.tableColH}>
                <Text style={styles.tableCell}>Cliente</Text>
              </View>
              <View style={styles.tableColH}>
                <Text style={styles.tableCell}>Asunto</Text>
              </View>
              <View style={styles.tableColH}>
                <Text style={styles.tableCell}>Monto/Cuantia</Text>
              </View>
              <View style={styles.tableColH}>
                <Text style={styles.tableCell}>Presentacion</Text>
              </View>
              <View style={styles.tableColH}>
                <Text style={styles.tableCell}>Ejecutoria</Text>
              </View>
              <View style={styles.tableColH}>
                <Text style={styles.tableCell}>Actualizado</Text>
              </View>
            </View>
          </View>

          {props.data.map(i => {
            return (
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{i.title}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{i.body}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{i.asunto}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{i.monto}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>
                      {i.filterEjecAmp
                        ? i.fase3O.fechaPrestAmpar
                          ? moment(i.fase3O.fechaPrestAmpar.toDate()).format(
                              "DD/MM/YYYY"
                            )
                          : ""
                        : ""}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>
                      {i.filterEjecAmp
                        ? i.fase3O.fechaEjecuAmpar
                          ? moment(i.fase3O.fechaEjecuAmpar.toDate()).format(
                              "DD/MM/YYYY"
                            )
                          : ""
                        : ""}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>
                      {moment(i.timestamp.toDate()).format("DD/MM/YYYY")}
                    </Text>
                  </View>
                </View>
              </View>
            );
          })}
        </View>
        <Text style={styles.footer} fixed>
          {`${props.direccion} \n ${props.ciudad} \n ${props.telefono}`}
        </Text>
      </Page>
    </Document>
  );
};

export default MyDocument;
